<script setup lang="ts">
import { DentalAndVisionApplicant } from '@/application/shared/domain/DentalAndVisionApplicant';
import { RenderName, RenderDate, RenderYesNoAnswer, RenderAddress, RenderMedicareStatus, RenderSsn } from '@hfc/ui-core';

const props = withDefaults(defineProps<{
  applicant: DentalAndVisionApplicant,
  iconsColor?: string,
  titleClass?: string,
}>(), {
  iconsColor: 'text-blue-500',
  titleClass: 'text-sm font-medium'
});

</script>
<template>
  <div class="flex flex-1 flex-col sm:flex-row pt-4 space-y-3 sm:space-y-0">
    <div class="flex-1 space-y-3">
      <div class="font-bold">
        <RenderName :first-name="props.applicant.first_name" :middle-name="props.applicant.middle_name" :last-name="props.applicant.last_name" :suffix="props.applicant.suffix" :icon-color="iconsColor" />
      </div>
      <div>
        <RenderDate :date="props.applicant.date_of_birth" :icon-color="iconsColor" />, <span class="capitalize">{{ props.applicant.gender }}</span>
      </div>
      <div>
        <RenderSsn v-if="props.applicant.ssn" :ssn="props.applicant.ssn.toString()" icon-class="mr-2 text-gray-400" show-obfuscation-toggle obfuscation-toggle-class="text-sm text-blue-500" obfuscate />
      </div>
    </div>
    <div class="flex-1">
      <div v-if="props.applicant.is_address_same_as_main" class="flex">
        <RenderYesNoAnswer :question="'Same as primary address?'" :answer="props.applicant.is_address_same_as_main"  :title-class="titleClass"/>
      </div>
      <div v-else>
        <RenderAddress
          :line-one="props.applicant.main_address?.line_one"
          :line-two="props.applicant.main_address?.line_two"
          :city="props.applicant.main_address?.city"
          :state="props.applicant.main_address?.state"
          :zip="props.applicant.main_address?.zip_code"
          :two-lines="true"
          :icon-color="iconsColor"
        />
      </div>
    </div>
    <div class="flex flex-1 flex-col">
      <span class="text-sm mr-4" :class="titleClass">Medicare status</span>
      <RenderMedicareStatus v-if="props.applicant.eligible_medicare" :status="props.applicant.eligible_medicare" />
    </div>
  </div>
</template>
